import React from "react";
import { useNavigate } from "react-router-dom";

const OriginSection = () => {
  const navigate = useNavigate(); // ✅ Correct placement

  return (
    <section className="bg-green-50 py-20 px-6">
      {/* Origin Content */}
      <div
        className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10"
        data-aos="fade-up"
      >
        {/* Image */}
        <div className="w-full md:w-1/2">
          <img
            src="/Website-Photos-1.png"
            alt="Shri Mataji"
            className="w-full h-auto rounded-xl shadow-md border border-green-100"
          />
        </div>

        {/* Text Content */}
        <div className="w-full md:w-1/2">
          <p className="text-green-700 font-semibold uppercase mb-2 tracking-wide">
            About Sahaja Yoga
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-snug">
            The Origin of Sahaja Yoga
          </h2>
          <p className="text-gray-700 leading-relaxed mb-6 text-justify">
            Sahaja Yoga was founded in 1970 by Nirmala Srivastava (1923–2011), known by millions of
            Her spiritual followers as <strong>Shri Mataji Nirmala Devi</strong>. Shri Mataji
            discovered a divine technique to awaken the Kundalini energy within human beings. She
            devoted Her life to teaching people of all nationalities, races, and religions how to
            connect with their inner Self. Her vision of a joyful and spiritually evolved society is
            being realized by millions across the world today.
          </p>

          {/* Quote */}
          <div className="mt-8 border-l-4 border-green-600 pl-6 text-gray-700 italic text-lg leading-relaxed">
            “You cannot know the meaning of your life until you are connected to the Power that
            created you.”
            <br />
            <span className="block text-right mt-2 font-semibold text-green-800">
              – H.H. Shri Mataji Nirmala Devi
            </span>
          </div>

          {/* Button */}
          <div className="mt-6">
            <button
              onClick={() => navigate("/shrimataji")}
              className="bg-green-700 text-white font-medium px-6 py-3 rounded-full hover:bg-green-800 transition shadow-md"
            >
              Read More
            </button>
          </div>
        </div>
      </div>

      {/* Timeline Section */}
      <div className="mt-20 max-w-5xl mx-auto px-2">
        <div className="text-center mb-10">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
            Journey of Sahaja Yoga
          </h3>
          <p className="text-gray-600">
            A few key milestones in the spread of Shri Mataji’s divine work
          </p>
        </div>

        <div className="space-y-6 max-w-3xl mx-auto">
          {[
            { year: "1970", event: "Sahaja Yoga founded by Shri Mataji in Nargol, India" },
            { year: "1980s", event: "Spread to Europe, Australia, and North America" },
            {
              year: "1990s",
              event: "International public programs & global meditation tours",
            },
            {
              year: "2000–Present",
              event: "Millions practicing Sahaja Yoga in 100+ countries",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="relative pl-6 border-l-2 border-green-600"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="absolute left-0 top-1 w-3 h-3 bg-green-700 rounded-full"></div>
              <p className="text-sm text-gray-500">{item.year}</p>
              <p className="text-gray-700 font-medium">{item.event}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OriginSection;
